export default __webpack_public_path__ + "static/media/ice-swg.951ef791.jpeg";